<template>
    <form @submit.prevent="submit" class="flex flex-col mt-12">
        <InputGroup type="text" name="companyName" v-model="form.companyName"
                    :error="this.$page.props.errors.companyName"
                    label="opportunities.form.company_name"/>
        <SelectInputGroup name="industry" v-model="form.industry"
                          :options="industryOptions"
                          :error="this.$page.props.errors.industry" label="opportunities.form.industry"/>
        <InputGroup type="text" name="firstName" v-model="form.firstName"
                    :error="this.$page.props.errors.firstName" label="opportunities.form.first_name"/>
        <InputGroup type="text" name="lastName" v-model="form.lastName"
                    :error="this.$page.props.errors.lastName" label="opportunities.form.last_name"/>
        <InputGroup type="email" name="email" v-model="form.email" :error="this.$page.props.errors.email"
                    label="opportunities.form.email"/>
        <InputGroup type="tel" name="phone" v-model="form.phone" :error="this.$page.props.errors.phone"
                    label="opportunities.form.phone"/>
        <InputGroup type="number" name="numberEmployees" v-model="form.numberEmployees"
                    :error="this.$page.props.errors.numberEmployees"
                    label="opportunities.form.number_employees"/>
        <TextAreaGroup name="description" v-model="form.description" :error="this.$page.props.errors.description"
                       label="opportunities.form.peculiarities"
                       placeholder="opportunities.form.peculiarities_placeholder"
                       rows="7"/>
        <div class="lg:ml-60 lg:pl-6 lg:mr-auto mt-4">
            <Button>
                {{ $__('opportunities.form.sent') }}
            </Button>
        </div>
        <div>
            <FormResponseMessage/>
        </div>
    </form>
</template>

<script>
import InputGroup from "@/Components/Form/InputGroup";
import TextAreaGroup from "@/Components/Form/TextAreaGroup";
import Button from "@/Components/Form/Button"
import FormResponseMessage from "@/Components/Opportunities/Forms/ResponseMessage"
import SelectInputGroup from "@/Components/Form/SelectInputGroup";

export default {
    components: {
        SelectInputGroup,
        InputGroup,
        TextAreaGroup,
        Button,
        FormResponseMessage
    },
    data: () => ({
        form: {
            companyName: null,
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            numberEmployees: null,
            description: null,
        },
        industryOptions: [
            {
                name: 'opportunities.form.industryOptions.healthcare',
                value: 'Healthcare',
            },
            {
                name: 'opportunities.form.industryOptions.hospitality',
                value: 'Hospitality',
            },
            {
                name: 'opportunities.form.industryOptions.leisure',
                value: 'Leisure',
            },
            {
                name: 'opportunities.form.industryOptions.manufacturing',
                value: 'Manufacturing',
            },
            {
                name: 'opportunities.form.industryOptions.retail-non-food',
                value: 'Retail',
            },
            {
                name: 'opportunities.form.industryOptions.retail-food',
                value: 'Retail Food',
            },
            {
                name: 'opportunities.form.industryOptions.other',
                value: 'Other',
            },
        ],
    }),
    methods: {
        submit() {
            this.$inertia.post(route(this.$page.props.locale + '.opportunities.store'), this.form, {
                onSuccess: () => this.form = {
                    companyName: null,
                    firstName: null,
                    lastName: null,
                    email: null,
                    phone: null,
                    numberEmployees: null,
                    description: null,
                },
            })
        },
    },
}
</script>
